import Axios from 'axios';
import { buildWebStorage, setupCache } from 'axios-cache-interceptor';

// import { setupCache, buildWebStorage } from 'axios-cache-interceptor/dev';

import { hash, isBrowser } from '../helpers/common';

export const API_BASE = import.meta.env.VITE_API_BASE;
const debug = import.meta.env.VITE_DEBUG === 'true';

export interface ApiResponse {
  error: number
  message: null | string
  response: any
}
const instance = Axios.create();
const axios = isBrowser() ? setupCache(instance, { 
  debug: console.log,
  methods: ['get', 'post'],
  // As localStorage is a public storage, you can add a prefix
  // to all keys to avoid collisions with other code.
  storage: buildWebStorage(window.sessionStorage, 'axios-cache:')
}) : setupCache(instance);

if (import.meta.env.VITE_API_USE_THROTTLE === 'true') {
  // axiosThrottle.use(axios, { requestsPerSecond: 0.20 });
}


const cacheResponse = (key: string, data: any) => {
  isBrowser() && window.sessionStorage.setItem(key, JSON.stringify(data));
}

const getResponse = (key: string): any => {
  const result = isBrowser() && window.sessionStorage.getItem(key)
  return typeof result === "string" ? JSON.parse(result) : null;
}

export const clearAxiosCache = () => {
  // sessionStorage.clear();
  isBrowser() && window.sessionStorage.removeItem('authenticated')
  isBrowser() && window.sessionStorage.removeItem('oauthCode')
}

export const endpoint = axios.create({
  baseURL: API_BASE,
  timeout: 180000,
});

// Add auth token to headers if present
endpoint.interceptors.request.use(
  (config: any) => {
    // Get the token from local storage
    const token = isBrowser() && window.localStorage.getItem("token");

    // If the token exists, add it to the request headers
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error: any) => {
    return Promise.reject(error);
  }
);

export const endpointBlob = axios.create({
  baseURL: API_BASE,
  timeout: 180000,
  responseType: "blob"
});

// Add auth token to headers if present
endpointBlob.interceptors.request.use(
  (config: any) => {
    // Get the token from local storage
    const token = isBrowser() && window.localStorage.getItem("token");

    // If the token exists, add it to the request headers
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error: any) => {
    return Promise.reject(error);
  }
);

export const getAxios = async (url: string, useCache = true, params = {}) => {
  const reqUrl = `${API_BASE}${url}`
  const key = `cache:${hash(reqUrl)}`
  let result = useCache ? getResponse(key) : null
  if (debug && useCache) {
    console.log(`getAxios cache result: ${key}`, {result})
  }
  if (!result) {
    if (debug) {
      console.log(`getAxios start get: ${reqUrl}`)
    }
    result = await endpoint.get(reqUrl, {
      responseType: 'json',
      params: {
        ...params
      }
    })
    if (debug) {
      console.log(`getAxios end get`)
    }
    if (useCache) {
      cacheResponse(key, result)   
    }
  }
  if (debug) {
    console.log(`getAxios response result: ${key}`, {result})
  }
  return result
}

export const postAxios = async (url: string, postData: any, useCache = true, isBlob = false) => {
  const reqUrl = `${API_BASE}${url}`

  // remove access token so cached data can be reused between refreshed token
  const usePostData = {...postData}
  delete usePostData.access_token

  const key = `cache:${hash(`${reqUrl}${JSON.stringify(usePostData)}`)}`
  let result = useCache ? getResponse(key) : null
  if (debug) {
    console.log(`postAxios: ${key}`, {result})
  }
  if (!result) {
    result = await (isBlob ? endpointBlob : endpoint).post(reqUrl, postData)
    // const {code} = result?.data?.response
    // // unauthorised
    // if (code === 401) {

    // }
    if (useCache) {
      cacheResponse(key, result)
    }
  }
  return result
}

export const err = (message = "Unspecified error...", status = 500) => {
  return {
    error: status,
    message,
    response: null
  }
}

export const res = (response: any) => {
  return {
    error: 200,
    message: null,
    response
  }
}

export const processError = (e: any, defaultMessage: string, redirectWhenNotLoggedIn = false) => {
  let status = 500
  let message = defaultMessage
  if (Object.prototype.hasOwnProperty.call(e, 'status')) {
    status = e.status
    message = e.response.data.msg || defaultMessage

    // if (redirectWhenNotLoggedIn && (status === 401 || status === 403)) {
    //   logout()
    //   // debugger
    //   if (isBrowser()) {
    //     window.location.href = '/login'
    //   }
    // }

  }
  return {status, message}  
}

